<template>
  <div style="padding-left:50px;padding-right:50px" class="p-mt-6 p-mb-6">
    <h3 class="titulo-admin">{{isCreation?'Creación':'Edición'}} de Artículos</h3>
    <div class="p-grid">
      <div class="p-field p-col-12 p-md-12" v-if="typeTransaction != 'revisar'">
        <!-- <Button
          icon="pi pi-times"
          class="p-button-rounded p-button-danger p-button-text"
          @click="eliminarAvatar"
          v-if="
            this.usuario.id && this.usuario.avatar != '' && !avatarFueTocado
          "
        /> -->
        <label for="avatar" class="custom-file-upload">Imagen Cabecera</label>
        <input
          type="file"
          id="avatar"
          accept="image/jpeg"
          @change="onUpload($event)"
        />
        <span class="p-ml-3">{{ nombreFile }}</span>
        <span
          v-if="sizeFile > 0"
          style="font-size: 12px;font-weight: 700;margin-left: 5px;"
          >{{ sizeFile.toFixed(2) }}Kb</span
        >
      </div>
      <div class="p-field p-col-12" v-if="imagenSelectedBase64">
        <img :src="imagenSelectedBase64" alt="" class="imagenMuestra" />
      </div>
      <div class="p-field p-col-12 ">
        <div class="p-fluid">
          <div class="p-field">
            <label for="titulo">Titulo</label>
            <InputText
              id="titulo"
              v-model.trim="item.titulo"
              autofocus
              :disabled="typeTransaction == 'revisar'"
            />
          </div>
          <div class="p-field">
            <label for="autor">Autor</label>
            <InputText
              id="autor"
              v-model.trim="item.autor"
              autofocus
              :disabled="typeTransaction == 'revisar'"
            />
          </div>
          <div class="p-field">
            <label for="resumen">Resumen</label>
            <Textarea
              v-model.trim="item.resumen"
              rows="3"
              cols="12"
              maxlength="250"
              :disabled="typeTransaction == 'revisar'"
            />
          </div>
          <div class="p-field">
            <label for="referencias">Referencias</label>
            <InputText
              id="referencias"
              v-model.trim="item.referencias"
              autofocus
              :disabled="typeTransaction == 'revisar'"
            />
          </div>
          <div class="p-field">
            <label for="activo">Activo</label>
            <div class="p-formgroup-inline">
              <div
                v-for="(tipo_actividad, index) in tipos_estado"
                :key="index"
                class="p-field-radiobutton"
              >
                <RadioButton
                  :id="index"
                  name="publicado"
                  :value="tipo_actividad.value"
                  v-model="item.activo"
                  autofocus
                  :disabled="typeTransaction == 'revisar'"
                />
                <label :for="index">{{ tipo_actividad.name }}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="p-field p-col-12">
        <p style="padding: 20px;background-color: white;border: 1px solid #e0e0e0;border-radius: 3px;" v-if="typeTransaction == 'revisar'">
          <span v-html="item.cuerpo"></span>
        </p>
        <Editor
          v-model="item.cuerpo"
          editorStyle="height: 320px"
          v-if="typeTransaction != 'revisar'"
        >
          <template #toolbar>
            <span class="ql-formats">
              <button class="ql-bold" v-tooltip.bottom="'Bold'" name="bold"></button>
              <button class="ql-italic" v-tooltip.bottom="'Italic'" name="italic"></button>
              <button
                class="ql-underline"
                v-tooltip.bottom="'Underline'"
                name="subrayado"
              ></button>
            </span>
            <span class="ql-formats">
              <button class="ql-list" value="ordered" name="enumerado"></button>
              <button class="ql-list" value="bullet" name="ordenado"></button>
            </span>
          </template>
        </Editor>
      </div>
      <div class="p-field p-col-12" v-if="typeTransaction == 'revisar' || typeTransaction == 'edit'">
        <div class="p-fluid">
          <div class="p-field">
            <label for="comentarios_del_revisor">Comentario del Revisor</label>
            <Textarea
              v-model.trim="item.comentarios_del_revisor"
              rows="3"
              cols="12"
              maxlength="250"  
              :disabled="typeTransaction == 'edit'"        
            />
          </div>
        </div>
      </div>
      <div class="p-field p-col-12 p-text-center">
        <Button
          style="width:250px;justify-content:center"
          @click="crearArticulo"
          :disabled="loading"
          v-if="typeTransaction == 'create'"
          name="nuevo"
        >
          Crear Artículo<i
            class="pi pi-spin pi-spinner p-ml-2"
            style="fontSize: 1rem"
            v-if="loading"
          ></i
        ></Button>
        <Button
          style="width:250px;justify-content:center"
          @click="editarArticulo"
          :disabled="loading"
          v-else-if="typeTransaction == 'edit'"
          name="editar"
        >
          Guardar Cambios<i
            class="pi pi-spin pi-spinner p-ml-2"
            style="fontSize: 1rem"
            v-if="loading"
          ></i
        ></Button>
        <Button
          style="width:250px;justify-content:center"
          @click="comentarArticulo"
          :disabled="loading"
          v-else
          name="comentar"
        >
          Guardar Comentario<i
            class="pi pi-spin pi-spinner p-ml-2"
            style="fontSize: 1rem"
            v-if="loading"
          ></i
        ></Button>
      </div>
    </div>
  </div>
</template>

<script>
import ArticulosService from "../service/articulos.service";
export default {
  metaInfo: {
    title: 'Backoffice - QualityCare',
    htmlAttrs: {
      lang: 'es',
    },
    meta: [
      {
        name: 'Backoffice - QualityCare',
        content: 'Administración del sitio web',
      },
    ],
  },
  name: "articulos_creacion",
  data() {
    return {
      articulosService: null,
      item: {},
      loading: false,
      avatarFueTocado: false,
      nombreFile: "",
      sizeFile: "",
      typeFile: 0,
      file: null,
      tipos_estado: [
        { name: "NO", value: 0 },
        { name: "SI", value: 1 },
      ],
      imagenSelectedBase64: null,
      typeTransaction: "create",
    };
  },
  created() {
    this.articulosService = new ArticulosService();
    if (this.$route.name == "editar_articulos") {
      this.typeTransaction = "edit";
      this.id = this.$route.params.id;
    }
    if (this.$route.name == "revisar_articulo") {
      this.typeTransaction = "revisar";
      this.id = this.$route.params.id;
    }
  },
  mounted() {
    if (this.typeTransaction == "edit" || this.typeTransaction == "revisar") {
      this.getArticulo();
    }
  },
  methods: {
    getArticulo() {
      this.loading = true;
      this.articulosService
        .getArticuloByIdForEdition(this.id)
        .then((result) => {
          if (result.data.data.length == 0) {
            this.$router.push({ name: "main" });
          } else {
            this.item = { ...result.data.data };
            if (this.item.imagen != "") {
              this.imagenSelectedBase64 = this.item.imagen;
            }
            this.loading = false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "Error al recuperar el artículo",
            life: 3000,
          });
          this.loading = false;
        });
    },
    crearArticulo() {
      this.loading = true;
      let dataArticulo = new FormData();
      if (this.file) {
        dataArticulo.append("imagencabecera", this.file);
      }
      dataArticulo.append("datos", JSON.stringify(this.item));
      this.articulosService
        .crearArticulo(dataArticulo)
        .then((result) => {
          if (!result.data.data) {
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error al guardar artículo",
              life: 3000,
            });
            this.loading = false;
          } else {
            this.loading = false;
            this.$toast.add({
              severity: "success",
              summary: "Felicidades",
              detail: "Artículo creado satisfactoriamente",
              life: 3000,
            });
            this.$router.push({ name: "mis_articulos" });
          }
        })
        .catch((err) => {
          console.log(err);
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "Error al guardar artículo",
            life: 3000,
          });
          this.loading = false;
        });
    },
    editarArticulo() {
      this.loading = true;
      let dataArticulo = new FormData();
      if (this.file) {
        dataArticulo.append("imagencabecera", this.file);
      }
      dataArticulo.append("datos", JSON.stringify(this.item));
      this.articulosService
        .editarArticulo(dataArticulo)
        .then((result) => {
          if (!result.data.data) {
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error al editar articulo",
              life: 3000,
            });
            this.loading = false;
          } else {
            this.loading = false;
            this.$toast.add({
              severity: "success",
              summary: "Felicidades",
              detail: "Artículo editado satisfactoriamente",
              life: 3000,
            });
            this.$router.push({ name: "mis_articulos" });
          }
        })
        .catch((err) => {
          console.log(err);
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "Error al editar articulo",
            life: 3000,
          });
          this.loading = false;
        });
    },
    comentarArticulo() {
      this.loading = true;
      this.articulosService
        .comentarPorRevisorArticulo(this.item)
        .then((result) => {
          if (!result.data.data) {
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error al comentar articulo",
              life: 3000,
            });
            this.loading = false;
          } else {
            this.loading = false;
            this.$toast.add({
              severity: "success",
              summary: "Felicidades",
              detail: "Artículo comentar satisfactoriamente",
              life: 3000,
            });
            this.$router.push({ name: "articulos_admin" });
          }
        })
        .catch((err) => {
          console.log(err);
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "Error al comentar articulo",
            life: 3000,
          });
          this.loading = false;
        });
    },
    onUpload(event) {
      this.nombreFile =
        event.target.files.length == 0 ? "" : event.target.files[0].name;
      this.sizeFile =
        event.target.files.length == 0 ? 0 : event.target.files[0].size / 1024;
      this.typeFile =
        event.target.files.length == 0 ? "" : event.target.files[0].type;
      this.imagenSelectedBase64 = null;
      if (event.target.files.length == 0) {
        this.file = null;
        this.nombreFile = "";
        this.sizeFile = 0;
        this.typeFile = "";
        this.avatarFueTocado = false;
      } else if (
        this.typeFile.indexOf("jpg") == -1 &&
        this.typeFile.indexOf("jpeg") == -1
      ) {
        this.file = null;
        this.nombreFile = "";
        this.sizeFile = 0;
        this.typeFile = "";
        this.avatarFueTocado = false;
        this.$toast.add({
          severity: "warn",
          summary: "Alerta",
          detail: "El archivo del avatar debe ser jpg ó jpeg",
          life: 3000,
        });
      } else if (this.sizeFile > 3096) {
        this.file = null;
        this.nombreFile = "";
        this.sizeFile = 0;
        this.typeFile = "";
        this.avatarFueTocado = false;
        this.$toast.add({
          severity: "warn",
          summary: "Alerta",
          detail: "El archivo del avatar no debe ser mayor a 3Mb",
          life: 3000,
        });
      } else if (this.sizeFile <= 0) {
        this.file = null;
        this.nombreFile = "";
        this.sizeFile = 0;
        this.typeFile = "";
        this.avatarFueTocado = false;
        this.$toast.add({
          severity: "warn",
          summary: "Alerta",
          detail: "El archivo del avatar debe ser jpg ó jpeg no mayor a 3Mb",
          life: 3000,
        });
      } else {
        this.file = event.target.files[0];
        this.avatarFueTocado = true;
        this.getBase64(this.file);
      }
    },
    getBase64(file) {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        console.log(reader.result);
        this.imagenSelectedBase64 = reader.result;
      };
      reader.onerror = (error) => {
        console.log("Error: ", error);
      };
    },
  },
  computed: {
    isCreation() {
      return this.$route.name == "crear_articulos";
    },
  },
};
</script>

<style scoped>
input[type="file"] {
  display: none;
}
.custom-file-upload {
  border: 1px solid #ccc;
  display: inline-block;
  padding: 6px 12px;
  cursor: pointer;
}
@media screen and (max-width: 800px) {
.imagenMuestra{
  width: 100%;
}
}
</style>
